import { render, staticRenderFns } from "./PreviewEmbed.vue?vue&type=template&id=6096c038&scoped=true"
import script from "./PreviewEmbed.vue?vue&type=script&lang=js"
export * from "./PreviewEmbed.vue?vue&type=script&lang=js"
import style0 from "./PreviewEmbed.vue?vue&type=style&index=0&id=6096c038&prod&lang=css"
import style1 from "./PreviewEmbed.vue?vue&type=style&index=1&id=6096c038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096c038",
  null
  
)

export default component.exports